import React, { useEffect, useState } from 'react';
import { Breadcrumbs } from '@gerdau/hefesto-mais-web';
import { Title } from '@gerdau/hefesto';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';
import { ERoutes } from '../../../routes';
import { ApplicationState } from '../../../store';
import { loadContractsV2 } from '../../../store/ducks/fabrication-contracts/actions';
import { updateFabricationPurchaseOrderSettings } from '../../../store/ducks/fabrication-purchase-order/actions';
import { ECustomerTypeView } from '../../../store/ducks/user/types';
import { EPurchaseRoutes } from '../purchase.routes';
import FabricationTabs from './FabricationTabs';
import FabricationRoutes, { EFabricationRoutes } from './fabrication.routes';
import {
  Container,
  ContainerFacelift,
  FabricationWrapper,
  Subtitle
} from './styles';
import LoadingModal from '../../../components/LoadingModal';

const Fabrication: React.FC = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const history = useHistory();

  const userState = useSelector((state: ApplicationState) => state.user);
  const fabricationPurchaseOrder = useSelector(
    (appState: ApplicationState) => appState.fabricationPurchaseOrder
  );
  const fabricationProjectsState = useSelector(
    (appState: ApplicationState) => appState.fabricationProjects
  );

  const [constructionIdentificationState, setConstructionIdentificationState] =
    useState(fabricationPurchaseOrder.constructionIdentification);
  const [detailingProjectState, setDetailingProjectState] = useState(
    fabricationPurchaseOrder.detailingProject
  );
  const [extraItensState, setExtraItensState] = useState(
    fabricationPurchaseOrder.extraItens
  );

  const contractsState = useSelector(
    (appState: ApplicationState) => appState.fabricationContracts
  );

  const getBreadcrumbs = () => {
    return [
      { name: 'Comprar', url: ERoutes.PURCHASE },
      {
        name: 'Solicitar novo pedido',
        url: `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}${EFabricationRoutes.CONSTRUCTION_IDENTIFICATION}`
      },
      ...(pathname.includes(EFabricationRoutes.LAST_ORDERS)
        ? [
            {
              name: 'Histórico de pedidos',
              url: ''
            }
          ]
        : [])
    ];
  };

  if (
    pathname ===
    `${ERoutes.PURCHASE}/${EPurchaseRoutes.FABRICATION}${EFabricationRoutes.CONSTRUCTION_IDENTIFICATION}`
  ) {
    getBreadcrumbs();
  }

  const loadContractsIfNeed = () => {
    if (
      !userState.isManager &&
      contractsState.contracts === undefined &&
      !contractsState.loading &&
      !contractsState.error
    ) {
      dispatch(loadContractsV2());
    }
  };

  useEffect(() => {
    loadContractsIfNeed();
  });

  const updateFabricationOrderState = () => {
    if (
      !pathname.includes(EFabricationRoutes.SUCCESS) &&
      !pathname.includes(EFabricationRoutes.CHECKOUT)
    ) {
      dispatch(
        updateFabricationPurchaseOrderSettings({
          ...fabricationPurchaseOrder,
          constructionIdentification: constructionIdentificationState,
          detailingProject: detailingProjectState,
          extraItens: extraItensState
        })
      );
    }
  };

  useEffect(() => {
    if (
      fabricationPurchaseOrder.constructionIdentification.comingFromBuyAgain
    ) {
      if (
        fabricationPurchaseOrder.constructionIdentification !==
        constructionIdentificationState
      ) {
        setConstructionIdentificationState(
          fabricationPurchaseOrder.constructionIdentification
        );
      }
      if (fabricationPurchaseOrder.detailingProject !== detailingProjectState) {
        setDetailingProjectState(fabricationPurchaseOrder.detailingProject);
      }
      if (fabricationPurchaseOrder.extraItens !== extraItensState) {
        setExtraItensState(fabricationPurchaseOrder.extraItens);
      }
    }
  }, [
    fabricationPurchaseOrder.constructionIdentification,
    fabricationPurchaseOrder.detailingProject
  ]);

  // dispara ação de atualizar estado quando trocar de página
  useEffect(() => {
    const unlisten = history.listen(() => {
      updateFabricationOrderState();
    });

    return () => {
      unlisten();
    };
  });

  return (
    <FabricationWrapper>
      <ContainerFacelift
        isEmitter={userState.searchCustomerType === ECustomerTypeView.EMITTER}
      >
        {userState.searchCustomerType === ECustomerTypeView.EMITTER &&
          !pathname.includes(EFabricationRoutes.FABRICATION_REVIEW_ORDER) && (
            <Breadcrumbs
              breadcrumbItems={getBreadcrumbs()}
              onClick={(e) => {
                history.push(e);
              }}
            />
          )}

        {!pathname.includes(EFabricationRoutes.LAST_ORDERS) &&
          !pathname.includes(EFabricationRoutes.FABRICATION_REVIEW_ORDER) && (
            <div>
              <Title level={1}>Solicitação de corte e dobra</Title>
              <Subtitle>
                Solicite aços cortados e dobrados de acordo com a necessidade
                dos seus projetos.
              </Subtitle>
            </div>
          )}

        {!pathname.includes(EFabricationRoutes.LAST_ORDERS) &&
          !pathname.includes(EFabricationRoutes.FABRICATION_REVIEW_ORDER) && (
            <FabricationTabs />
          )}
      </ContainerFacelift>
      <Container>
        <LoadingModal
          enabled={fabricationPurchaseOrder.finishOrderLoading}
          title="Conclusão do pedido"
          message="Pedido sendo enviado para fábrica da Gerdau"
        />

        <FabricationRoutes
          fabricationPurchaseOrder={fabricationPurchaseOrder}
          fabricationProjectsState={fabricationProjectsState}
          contractsState={contractsState}
          constructionIdentificationState={constructionIdentificationState}
          setConstructionIdentificationState={
            setConstructionIdentificationState
          }
          detailingProjectState={detailingProjectState}
          setDetailingProjectState={setDetailingProjectState}
          extraItensState={extraItensState}
          setExtraItensState={setExtraItensState}
        />
      </Container>
    </FabricationWrapper>
  );
};

export default Fabrication;
